import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./LanguageContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Features from "./components/Features";
import HowItWorks from "./components/HowItWorks";
import ServiceAreas from "./components/ServiceAreas";
import BookingForm from "./components/BookingForm";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import PaymentSuccess from "./components/PaymentSuccess";
import PaymentCancel from "./components/PaymentCancel";
import AdminDashboard from "./components/AdminDashboard";
import AdminLogin from "./components/AdminLogin";
import CustomerAuth from "./components/CustomerAuth";
import CustomerAccount from "./components/CustomerAccount";
import TermsConditions from "./components/TermsConditions";
import ReschedulePage from "./components/ReschedulePage";
import LaundryAssistant from "./components/LaundryAssistant";

const HomePage = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Services />
        <Features />
        <HowItWorks />
        <ServiceAreas />
        <BookingForm />
        <Testimonials />
      </main>
      <Footer />
      <LaundryAssistant />
    </>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<CustomerAuth />} />
            <Route path="/register" element={<CustomerAuth />} />
            <Route path="/account" element={<CustomerAccount />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/payment-cancel" element={<PaymentCancel />} />
            <Route path="/terms" element={<TermsConditions />} />
            <Route path="/reschedule" element={<ReschedulePage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </LanguageProvider>
  );
}

export default App;
